(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-customer-reviews"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
const trigger=event.target.closest('[data-blv-write-review]');if(!trigger)return;
const widget=document.getElementById('judgeme_product_reviews');if(!widget)return;
event.preventDefault();
widget.closest('[data-blv-review-app]')?.classList.add('is-writing-review');
const findButton=()=>widget.querySelector('[data-testid="write-review-button"],.jdgm-write-rev-link');
const native=findButton();if(native){native.click();return;}
if(trigger.getAttribute('aria-busy')==='true')return;
trigger.setAttribute('aria-busy','true');widget.scrollIntoView({block:'center'});
let timer;
const observer=new MutationObserver(()=>{
const button=findButton();if(!button)return;
observer.disconnect();clearTimeout(timer);trigger.removeAttribute('aria-busy');button.click();
});
observer.observe(widget,{childList:true,subtree:true});
timer=setTimeout(()=>{observer.disconnect();trigger.removeAttribute('aria-busy');},12000);
});
  document.querySelectorAll('[data-review-section]').forEach((section) => {
    const grid = section.querySelector('[data-review-grid]');
    const cards = Array.from(section.querySelectorAll('[data-review-card]'));
    const dialog = section.querySelector('[data-review-dialog]');
    const dialogContent = section.querySelector('[data-review-dialog-content]');
    const moreButton = section.querySelector('[data-review-more]');
    let activeFilter = 'all';
    let reviewsExpanded = false;

    const reviewMatchesFilter = (card) => (
      activeFilter === 'all' ||
      activeFilter === 'photo' && card.dataset.photo === 'true' ||
      card.dataset.rating === activeFilter
    );

    const refreshReviewVisibility = () => {
      const orderedCards = Array.from(grid.querySelectorAll('[data-review-card]'));
      const matchingCards = orderedCards.filter(reviewMatchesFilter);
      matchingCards.forEach((card, index) => {
        card.hidden = !reviewsExpanded && index >= 7;
      });
      orderedCards.filter((card) => !reviewMatchesFilter(card)).forEach((card) => {
        card.hidden = true;
      });
      if (moreButton) {
        moreButton.hidden = reviewsExpanded || matchingCards.length <= 7;
        moreButton.setAttribute('aria-expanded', String(reviewsExpanded));
      }
    };

    if (moreButton) {
      moreButton.addEventListener('click', () => {
        reviewsExpanded = true;
        refreshReviewVisibility();
      });
    }

    section.querySelectorAll('[data-review-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const template = button.closest('[data-review-card]').querySelector('[data-review-template]');
        dialogContent.innerHTML = template.innerHTML;
        dialog.showModal();
      });
    });

    section.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    section.querySelectorAll('[data-review-sort]').forEach((button) => {
      button.addEventListener('click', () => {
        const mode = button.dataset.reviewSort;
        const ordered = [...cards].sort((a, b) => {
          if (mode === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating);
          if (mode === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating);
          return String(b.dataset.date).localeCompare(String(a.dataset.date));
        });
        ordered.forEach((card) => grid.appendChild(card));
        refreshReviewVisibility();
        button.closest('details').removeAttribute('open');
      });
    });

    section.querySelectorAll('[data-review-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.reviewFilter;
        reviewsExpanded = false;
        section.querySelectorAll('[data-review-filter]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        refreshReviewVisibility();
        button.closest('details').removeAttribute('open');
      });
    });

    refreshReviewVisibility();
  });
  } catch(e) { console.error(e); }
})();

})();
